const masterchefv2 = require("./masterchef_v2");

module.exports = {
  UNIV2_ROUTER_ADDRESS: "0x1421bde4b10e8dd459b3bcb598810b1337d56842",
  FARMS: {
    masterchefv2
  },
};
